import * as yup from "yup";
export const courcenewSchema = yup.object().shape({
  courseName: yup.string().required("Course Name Is Required"),
  courceDes: yup.string(),
  courseUrl1: yup.string(),
  courseUrl2: yup.string(),
});

export const postingScheduleSchema = yup.object().shape({
  topic: yup.string().required("Topic is required"),
  description: yup.string(),
  id: yup.number(),
  filepath: yup.string().required("File URL is required"),
});
